import { defineStore } from 'pinia'
import { supportService } from '@/services/supportService'
import errorService from '@/services/errorService';

export const useSupportStore = defineStore('support', {
  state: () => ({
    supports: {
      meta: {}
    },
    support: {},
    filter: {},
    reply: {},
  }),

  actions: {
    async getSupports() {
      try {
        const response = await supportService.fetchSupports(this.filter);
        this.supports = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getSupport(id) {
      try {
        const response = await supportService.fetchSupport(id);
        this.support = response.data.data;

      } catch (error) {
        return errorService.handle(error);
      }
    },

    async addSupport(params) {

      try {
        const response = await supportService.createSupport(params);
        this.support = response.data.data;

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async addSupportReply(id, params) {
      
      try {
        const response = await supportService.replySupport(id, params);
        this.support.replies.push(response.data.data);

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },
    
  }
});